import { EventEmitter } from '../util/eventemitter';
import { ProxyObject } from './proxyobject';

export class GameObjectManager extends EventEmitter {
    objects: any[];

    constructor() {
        super();
      this.objects = [];
    }

    addObject(obj: any) {
      if (obj.serverObjectIdx <= 0) {
        console.warn('Attempted to add object with invalid server index.');
        return;
      }
      let foundProxyIdx = -1;
      for (let i = 0; i < this.objects.length; ++i) {
        if (this.objects[i] === obj) {
          console.warn('Attempted to add same object twice.');
          return;
        }
        if (this.objects[i].serverObjectIdx === obj.serverObjectIdx) {
          if (this.objects[i] instanceof ProxyObject) {
            foundProxyIdx = i;
            break;
          }
          console.warn('Attempted to add object with duplicate server index.');
          return;
        }
      }
      if (foundProxyIdx === -1) {
        this.objects.push(obj);
      } else {
        obj.ref = this.objects[foundProxyIdx].ref;
        obj.ref._object = obj;
        this.objects[foundProxyIdx] = obj;
      }
      this.emit('object_added', obj);
    }

    removeObject(obj: any) {
      const objIdx = this.objects.indexOf(obj);
      if (objIdx !== -1) {
        const proxyObj = new ProxyObject();
        proxyObj.serverObjectIdx = obj.serverObjectIdx;
        proxyObj.setPosition(obj.position.x, obj.position.y, obj.position.z);
        proxyObj.ref = obj.ref;
        proxyObj.ref._object = proxyObj;
        this.objects[objIdx] = proxyObj;
      }
      this.emit('object_removed', obj);
    }

    findByServerObjectIdx(objectIdx: any) {
      for (let i = 0;  i < this.objects.length; ++i) {
        const thisObject = this.objects[i];
        if (thisObject.serverObjectIdx === objectIdx) {
          return thisObject;
        }
      }
      return null;
    }

    getRefByServerObjectIdx(objectIdx: any, objectPos: any) {
      let foundObj = this.findByServerObjectIdx(objectIdx);
      if (!foundObj) {
        foundObj = new ProxyObject();
        foundObj.serverObjectIdx = objectIdx;
        this.addObject(foundObj);
      }
      if (foundObj instanceof ProxyObject) {
        foundObj.setPosition(objectPos.x, objectPos.y, objectPos.z);
      }
      return foundObj.ref;
    }

    update(delta: any) {
      for (let i = 0; i < this.objects.length; ++i) {
        this.objects[i].update(delta);
      }
    }

    findNearestMob(position: any) {
      return this._findNearestOfType('mob', position);
    }

    findNearestItem(position: any) {
      return this._findNearestOfType('item', position);
    }

    _findNearestOfType(type: string, position: any) {
      let nearest: any = null;
      let nearestDistSq = Infinity;
      for (let i = 0; i < this.objects.length; ++i) {
        const obj = this.objects[i];
        if (obj.type !== type) {
          continue;
        }
        const dx = obj.position.x - position.x;
        const dy = obj.position.y - position.y;
        const dz = obj.position.z - position.z;
        const distSq = dx * dx + dy * dy + dz * dz;
        if (distSq < nearestDistSq) {
          nearestDistSq = distSq;
          nearest = obj;
        }
      }
      return nearest;
    }

}

/**
 * @constructor
 */







